import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { _isNil } from 'majora/lodash';

export interface UrlParams {
	[key: string]: string | number;
}

@Injectable({
	providedIn: 'root',
})
export class UrlService {

	constructor(private http: HttpClient) {
	}

	buildQueryParam(key: string, value: string | number) {
		return key + '=' + encodeURIComponent(value);
	}

	getStrutsParameters(sessionId: string, userId: number, currentTime: Date): string {
		let urlParams = '';
		urlParams += `sessionId=${sessionId}`;
		urlParams += `&userId=${userId}`;
		urlParams += `&currTime=${currentTime.getTime()}`;
		return urlParams;
	}

	/* istanbul ignore next */
	openPopupWindow(a_url: string, a_name: string): void {
		window.open(a_url, a_name, 'toolbar=0,location=0,directories=0,status=0,menubar=1,resizable=1,scrollbars=1');
	}

	/* istanbul ignore next */
	openTabWithPost(url: string, sessionId: string, userId: number, urlTarget: string, params: UrlParams, isStrutsCall: boolean = true) {
		const queryParams = Object.entries(params)
			.filter(param => !_isNil(param[1]))
			.map(param => this.buildQueryParam(param[0], param[1]));

		if (isStrutsCall) {
			queryParams.push(this.getStrutsParameters(sessionId, userId, new Date()));
		}

		const fullUrl = queryParams.length > 0 ? `${url}?${queryParams.join('&')}` : url;

		this.openPopupWindow(
			fullUrl,
			urlTarget,
		);
	}

	/**
	 * Downloads a file from a URL by fetching it as a blob and triggering a download
	 */
	downloadFile(url: string, sessionId: string, userId: number, params: UrlParams, filename: string): Observable<void> {
		const queryParams = Object.entries(params)
			.filter(param => !_isNil(param[1]))
			.map(param => this.buildQueryParam(param[0], param[1]));

		queryParams.push(this.getStrutsParameters(sessionId, userId, new Date()));

		const fullUrl = `${url}?${queryParams.join('&')}`;

		return this.http.post(fullUrl, null, {
			responseType: 'blob',
		}).pipe(
			tap((blob: Blob) => {
				const blobUrl = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = blobUrl;
				link.download = filename;
				link.click();
				window.URL.revokeObjectURL(blobUrl);
			}),
			map(() => void 0),
		);
	}

}
